"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelCropParameterState = exports.CollectionModelCropParameterStateMutator = void 0;
var id_1 = require("../../../id");
var free_cropParameter_1 = require("./free.cropParameter");
function makeCropParameterState(tag, id) {
    switch (tag) {
        case 'free':
            return free_cropParameter_1.CollectionModelFreeCropParameter.state(id);
        default:
            throw new Error("Unknown marker type: \"".concat(tag, "\""));
    }
}
var CollectionModelCropParameterStateMutator = /** @class */ (function () {
    function CollectionModelCropParameterStateMutator(state) {
        this.state = state;
    }
    CollectionModelCropParameterStateMutator.prototype.getState = function () {
        var collectionState = this.state.collection.state;
        var captureCropParameterKey = CollectionModelCropParameterState.captureCropParameterId(this.state.captureId);
        var state = collectionState.getFieldValue(captureCropParameterKey);
        if (state == null) {
            return [];
        }
        return state.slice();
    };
    CollectionModelCropParameterStateMutator.prototype.setState = function (state) {
        var collectionState = this.state.collection.state;
        var captureCropParameterKey = CollectionModelCropParameterState.captureCropParameterId(this.state.captureId);
        collectionState.setFieldValue(captureCropParameterKey, state);
    };
    CollectionModelCropParameterStateMutator.prototype.create = function (tag, id) {
        if (id === void 0) { id = id_1.IkeId.generate(); }
        var state = makeCropParameterState(tag, id);
        return this.createWithState(state);
    };
    CollectionModelCropParameterStateMutator.prototype.remove = function (cropParameter) {
        var cropParameterIds = this.getState();
        var index = cropParameterIds.indexOf(cropParameter.id);
        if (index === -1) {
            throw new Error("Cannot remove crop correction. Instance \"".concat(cropParameter.id, "\" is missing from capture \"").concat(this.state.captureId, "\""));
        }
        cropParameterIds.splice(index, 1);
        this.setState(cropParameterIds);
        delete this.state.cropParameters[cropParameter.id];
        cropParameter.Mutator.destroyState();
    };
    CollectionModelCropParameterStateMutator.prototype.clear = function () {
        var cropParameters = this.state.values();
        for (var _i = 0, cropParameters_1 = cropParameters; _i < cropParameters_1.length; _i++) {
            var cropParameter = cropParameters_1[_i];
            var cropParameterIds = this.getState();
            var index = cropParameterIds.indexOf(cropParameter.id);
            if (index === -1) {
                continue;
            }
            this.remove(cropParameter);
        }
    };
    CollectionModelCropParameterStateMutator.prototype.createWithState = function (state) {
        var collectionState = this.state.collection.state;
        var captureId = this.state.captureId;
        var stateId = CollectionModelCropParameterState.cropParameterId(captureId, state.id);
        if (collectionState.fields.get(stateId) != null) {
            throw new Error("Crop Correction \"".concat(stateId, "\" already exists"));
        }
        collectionState.setFieldValue(stateId, state);
        var cropParameterState = this.getState();
        cropParameterState.push(state.id);
        this.setState(cropParameterState);
        return state.id;
    };
    return CollectionModelCropParameterStateMutator;
}());
exports.CollectionModelCropParameterStateMutator = CollectionModelCropParameterStateMutator;
var ID_PREFIX_CROP_CORRECTION = 'c';
var ID_PREFIX_CAPTURE_CROP_CORRECTION = 'cl';
var CollectionModelCropParameterState = /** @class */ (function () {
    function CollectionModelCropParameterState(collection, captureId) {
        this.Mutator = new CollectionModelCropParameterStateMutator(this);
        this.id = id_1.IkeId.generate();
        this.cropParameters = {};
        this.collection = collection;
        this.captureId = captureId;
    }
    CollectionModelCropParameterState.cropParameterId = function (captureId, cropParameterId) {
        return "".concat(ID_PREFIX_CROP_CORRECTION, ":").concat(captureId, ":").concat(cropParameterId);
    };
    CollectionModelCropParameterState.captureCropParameterId = function (captureId) {
        return "".concat(ID_PREFIX_CAPTURE_CROP_CORRECTION, ":").concat(captureId);
    };
    CollectionModelCropParameterState.getCaptureCropParameterId = function (key) {
        if (key.startsWith("".concat(ID_PREFIX_CAPTURE_CROP_CORRECTION, ":"))) {
            return key.substr(3);
        }
        return null;
    };
    CollectionModelCropParameterState.prototype.useInExportCorrection = function (cropParameterId) {
        if (!(this.hasCropParameter(cropParameterId))) {
            return false;
        }
        else {
            var brightness = this.getCropParameter(cropParameterId);
            switch (brightness.state.tag) {
                case 'free':
                    var free = this.getCropParameter(cropParameterId);
                    return (free.width > 0 && free.height > 0);
                default:
                    return false;
            }
        }
    };
    CollectionModelCropParameterState.prototype.hasCropParameter = function (cropParameterId) {
        return this.state.indexOf(cropParameterId) > -1;
    };
    CollectionModelCropParameterState.prototype.getCropParameter = function (cropParameterId) {
        var cropParameter = this.cropParameters[cropParameterId];
        if (cropParameter == null) {
            var cropParameterState = this.collection.state.getFieldValue(CollectionModelCropParameterState.cropParameterId(this.captureId, cropParameterId)); //FIXME
            if (cropParameterState == null) {
                //if we can't find a state with the current id, we recreate a new state with the same id, and query it again
                this.Mutator.create('free', cropParameterId);
                cropParameterState = this.collection.state.getFieldValue(CollectionModelCropParameterState.cropParameterId(this.captureId, cropParameterId));
            }
            switch (cropParameterState.tag) {
                case 'free':
                    cropParameter = new free_cropParameter_1.CollectionModelFreeCropParameter(this, cropParameterId, this.captureId);
                    break;
                default:
                    throw new Error("Capture ".concat(this.captureId, ":Unknown brighness correction type: \"").concat(cropParameterState.tag, "\""));
            }
            this.cropParameters[cropParameterId] = cropParameter;
        }
        return cropParameter;
    };
    CollectionModelCropParameterState.prototype.values = function () {
        var output = [];
        for (var _i = 0, _a = this.state; _i < _a.length; _i++) {
            var cropParameterId = _a[_i];
            var cropParameter = this.getCropParameter(cropParameterId);
            output.push(cropParameter);
        }
        return output;
    };
    CollectionModelCropParameterState.prototype.useInExportCorrections = function () {
        var _this = this;
        var state = false;
        if (this.hasCropParameters()) {
            this.state.forEach(function (el) {
                state = _this.useInExportCorrection(el);
            });
        }
        return state;
    };
    CollectionModelCropParameterState.prototype.hasCropParameters = function () {
        return this.state.length > 0;
    };
    Object.defineProperty(CollectionModelCropParameterState.prototype, "capture", {
        get: function () {
            return this.collection.state.getCapture(this.captureId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelCropParameterState.prototype, "state", {
        get: function () {
            return this.collection.state.getFieldValue(CollectionModelCropParameterState.captureCropParameterId(this.captureId)) || [];
        },
        enumerable: false,
        configurable: true
    });
    return CollectionModelCropParameterState;
}());
exports.CollectionModelCropParameterState = CollectionModelCropParameterState;
//# sourceMappingURL=cropParameter.state.js.map